import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { resolveNextViteImage } from '@infl-ts/util-resolve-next-vite-image';
import DescriptionIcon from '@mui/icons-material/Description';
import { Box, Button, styled, Typography } from '@mui/material';
import { pipe } from 'fp-ts/function';
import { Translation } from 'react-i18next';
import { fileTypeExt, imageTypes, previewVideoTypes, uniqTypesFromExts } from './file-type-white-list';
import videoCameraIcon from './images/videoCamera.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var UploadedImage = styled('img')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n"])));
export var UploadedFileInfo = function UploadedFileInfo(_ref) {
  var containerId = _ref.containerId,
      _ref$uploadedFile = _ref.uploadedFile,
      url = _ref$uploadedFile.url,
      mimetype = _ref$uploadedFile.mimetype,
      filename = _ref$uploadedFile.filename,
      onRemove = _ref.onRemove;
  return pipe(encodeURI(url), function (encodedUrl) {
    var _infl;

    return /*#__PURE__*/_jsxs(Box, {
      id: containerId,
      sx: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        pt: 7,
        pb: 2
      },
      children: [!url || uniqTypesFromExts(((_infl = window._infl) === null || _infl === void 0 ? void 0 : _infl.enabledExtensionsForFileUpload) || fileTypeExt).some(function (v) {
        return mimetype.includes(v);
      }) ? /*#__PURE__*/_jsx(DescriptionIcon, {
        sx: {
          mb: 2
        }
      }) : imageTypes.some(function (v) {
        return mimetype.includes(v);
      }) ? /*#__PURE__*/_jsx(Box, {
        sx: {
          position: 'relative',
          width: '100%',
          paddingBottom: '20%'
        },
        children: /*#__PURE__*/_jsx(UploadedImage, {
          alt: "User Uploaded Image",
          src: encodedUrl
        })
      }) : previewVideoTypes.some(function (v) {
        return mimetype.includes(v);
      }) ? /*#__PURE__*/_jsx("video", {
        width: "200px",
        height: "200",
        preload: "metadata",
        src: "".concat(encodedUrl, "#t=0.5")
      }) : mimetype === 'video/x-ms-wmv' || mimetype === 'video/avi' ? /*#__PURE__*/_jsx("img", {
        alt: "Uploaded Video Icon",
        src: resolveNextViteImage(videoCameraIcon),
        style: {
          height: '40px',
          width: '40px'
        }
      }) : null, /*#__PURE__*/_jsx(Typography, {
        sx: {
          width: '100%',
          wordWrap: 'break-word',
          p: 1,
          textAlign: 'center'
        },
        children: decodeURI(filename)
      }), /*#__PURE__*/_jsx(Button, {
        sx: {
          mt: 2
        },
        onClick: onRemove,
        children: /*#__PURE__*/_jsx(Translation, {
          children: function children(t) {
            return t('Remove');
          }
        })
      })]
    });
  });
};